import { makeStyles } from '@material-ui/core/styles'

export const MyProfileStyles = makeStyles((theme) => ({
  body: {
    height: 'calc(100% - 4px)',
    overflowY: 'clip',
  },
  jobsListContainer: {
    width: '100%',
    height: 421,
    maxHeight: 421,
    paddingLeft: '5px',
    paddingRight: '5px',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 251px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  marginLeft: {
    marginLeft: 3,
  },
  jobTitleText: {
    textAlign: 'left',
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 1,
    wordBreak: 'keep-all',
    overflow: 'hidden',
  },
  searchBar: {
    margin: theme.spacing(0.5),
  },
  searchIcon: {
    color: theme.palette.primary.main,
  },
  jobCardBackground: {
    height: 68,
    marginTop: 1,
    marginBottom: 4,
    marginRight: 4,
    padding: 4,
    paddingTop: 4,
    paddingBottom: 4,
    width: '100%',
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.backgroundColor.ternary,
    },
  },
  subText: {
    overflow: 'hidden',
    color: theme.palette.secondary.headerText,
    fontSize: 14,
    fontWeight: '500',
  },
  jobDetailContainer: {
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    overflowY: 'auto',
    height: 'calc(100dvh - 234px)',
    maxHeight: 444,
    width: 335,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  jobDetailButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(0.5),
  },
  jobDetailButtonApply: {
    background: theme.palette.base.green,
    color: theme.palette.base.white,
    '&:focus': {
      background: theme.palette.base.green,
    },
  },
  jobDetailButtonBack: {
    background: theme.palette.base.red,
    color: theme.palette.base.white,
  },
  jobSearchIcon: {
    color: '#00B339',
    fontSize: 100,
  },
  jobSearchNotFoundText: {
    fontWeight: 900,
    fontSize: 20,
    textAlign: 'center',
  },
  pagination: {
    width: '100%',
    justifyItems: 'center',
    marginBottom: theme.spacing(0.5),
  },
  noneFound: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
}))

export default MyProfileStyles
